import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsSnowNormalLarge = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M41.67 27.77l-6.52 2.38-5.14-3v-6.33l5.14-3 6.52 2.38.34-.94-5.74-2.06 5.66-3.27-.5-.87-5.66 3.27 1.06-6-1-.17L34.64 17l-5.14 3-5.5-3.22v-5.94l5.32-4.46-.64-.77L24 9.54V3h-1v6.54l-4.68-3.92-.64.77L23 10.84v5.94L17.5 20l-5.14-3-1.2-6.84-1 .17 1.06 6-5.66-3.26-.5.87 5.66 3.27L5 19.29l.34.94 6.52-2.38 5.14 3v6.35l-5.14 3-6.53-2.43-.33.94 5.74 2.09-5.68 3.27.5.87 5.66-3.27-1.06 6 1 .17 1.2-6.84 5.14-3 5.5 3.22v5.94l-5.32 4.46.64.77L23 38.46V45h1v-6.54l4.68 3.92.64-.77L24 37.16v-5.94L29.5 28l5.14 3 1.2 6.84 1-.17-1.06-6 5.66 3.27.5-.87-5.67-3.27L42 28.71zM29 27.18l-5.5 3.18-5.5-3.18v-6.36l5.5-3.18 5.5 3.18z"
  }));
});
SvgSportsSnowNormalLarge.defaultProps = {
  height: 48,
  width: 48
};
SvgSportsSnowNormalLarge.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsSnowNormalLarge;